import {DateTimeFormatter, LocalDateTime} from 'js-joda'
import Button from 'material-ui-next/Button'
import Card from 'material-ui-next/Card'
import CardContent from 'material-ui-next/Card/CardContent'
import Divider from 'material-ui-next/Divider'
import FormControl from 'material-ui-next/Form/FormControl'
import FormHelperText from 'material-ui-next/Form/FormHelperText'
import Input from 'material-ui-next/Input'
import InputAdornment from 'material-ui-next/Input/InputAdornment'
import InputLabel from 'material-ui-next/Input/InputLabel'
import ListItemText from 'material-ui-next/List/ListItemText'
import TextField from 'material-ui-next/TextField'
import Typography from 'material-ui-next/Typography'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import List from 'material-ui/List/List'
import ListItem from 'material-ui/List/ListItem'
import AlertError from 'material-ui/svg-icons/alert/error'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import * as R from 'ramda'
import * as React from 'react'
import injectSheet from 'react-jss'
import {errorMessage} from '../../Data/FormValidation'
import {formatPrice} from '../../Data/NumberHelper'
import * as PrismaRequest from '../../Entities/PrismaRequest'
import {authorName} from '../../Entities/PrismaRequestCommentWithUsers'
import * as PrismaRequestOfferType from '../../Entities/PrismaRequestOfferType'
import {downloadIcon} from '../../View/DownloadIcon'
import {WithClasses} from '../../View/Helper'
import {PrismaManufacturerStatusView} from '../../View/PrismaManufacturerStatusView'
import {minuteDateTimeFormatter} from '../../View/Utils'
import * as DownloadableFile from './../../Data/DownloadableFile'
import * as PrismaFile from './../../Entities/PrismaFile'
import * as PrismaFileType from './../../Entities/PrismaFileType'
import {PrismaRequestDetailsAction} from './PrismaRequestDetailsActions'
import {OfferForm, PrismaRequestDetailsState} from './PrismaRequestDetailsState'
import {PrismaRequestSubmitOfferModal} from './PrismaRequestSubmitOfferModal'
import {PrismaRequestDeclineOfferModal} from './PrismaRequestDeclineOfferModal'
import * as PrismaRequestDeliveryInformation from '../../Entities/PrismaRequestDeliveryInformation'
import MenuItem from 'material-ui-next/Menu/MenuItem'
import Select from 'material-ui-next/Select/Select'
import {ParcelDispatcher} from '../../Entities/ParcelDispatcher'
import {PrismaRequestMarkAsDispatchedModal} from './PrismaRequestMarkAsDispatchedModal'
import * as PrismaManufacturerStatus from '../../Entities/PrismaManufacturerStatus'

const styles = {}

interface Properties {
    readonly state: PrismaRequestDetailsState
    readonly dispatch: (action: PrismaRequestDetailsAction) => void
}

export const PrismaRequestDetailsView =
    injectSheet<Properties>(styles)(
        ({classes, state, dispatch}: WithClasses<Properties>) => {
            return (
                <div>
                    <div className="navigation">
                        <AppBar
                            title={`Prisma-Projekt #${state.prismaRequest.id}`}
                            className="navigation__bar"
                            iconElementLeft={
                                <IconButton
                                    onTouchTap={() =>
                                        dispatch({
                                            type: 'MenuButtonClicked',
                                        })}
                                >
                                    <NavigationMenu/>
                                </IconButton>}
                        />
                    </div>
                    <ContentView
                        state={state}
                        dispatch={dispatch}
                    />
                </div>
            )
        },
    )

const detailsContentStyles = {
    content: {
        padding: '40px',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'Wrap',
    },
    flexCard: {
        flex: '1',
        margin: '6px',
        padding: '24px',
    },
    flexCardPropertiesCard: {
        flex: '1',
        margin: '6px',
        padding: '24px',
        minWidth: '64.2%',
    },
    headline: {
        fontSize: '24px',
    },
    formControl: {
        margin: '42px 0',
    },
    formControlSmallMargin: {
        margin: '10px 0',
    },
    raisedButton: {
        color: 'white',
    },
    flexTable: {
        margin: '30px 0',
    },
    tableHeader: {
        padding: '10px 0',
        minWidth: '150px',
        fontWeight: '400',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: 'rgba(0,0,0,0.5)',
        textAlign: 'left',
    },
    description: {
        margin: '30px 0',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: 'rgba(0,0,0,0.5)',
        textAlign: 'left',
        whiteSpace: 'pre-wrap',
    },
    flexContent: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    flexColumn: {
        flex: '1',
    },
    divider: {
        margin: '40px 0',
    },
    commentaryContent: {
        width: '100%',
        padding: '16px 0',
    },
    commentaryForm: {
        width: '100%',
    },
    commentarySubmitButton: {
        color: 'white',
    },
    commentaryTextInput: {
        width: '100%',
        margin: '24px 0',
    },
    commentaryComment: {
        borderBottom: 'solid 1px #dddddd',
        padding: '24px 0',
    },
    commentaryCommentText: {
        marginTop: '16px',
        fontSize: '18px',
        whiteSpace: 'pre-wrap',
    },
    wrapLink: {
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        '-ms-word-break': 'break-all',
        wordBreak: 'break-all',
    },
}

export const ContentView =
    injectSheet<Properties>(detailsContentStyles)(
        ({classes, state, dispatch}: WithClasses<Properties>) => {
            const
                {
                    prismaRequest,
                    bpsUser,
                    translatedProductAttributes,
                    printOffer,
                    lithoOffer,
                    printProduct,
                    attachmentFiles,
                    proofCopyFiles,
                    printFiles,
                    printSapOrderNumber,
                    lithoSapOrderNumber,
                    assignedAdminName,
                    assignedAdminEmail,
                    deliveryInformation,
                    selectableParcelDispatchers,
                    selectedParcelDispatcher,
                    isSendingMarkAsDispatchedRequest,
                    isMarkAsDispatchedModalOpen,
                    trackingNumber,
                } = state
            return (
                <div className={classes.content}>
                    <div className={classes.row}>
                        <Card className={classes.flexCard}>
                            <CardContent>
                                <Typography
                                    component="h2"
                                    className={classes.headline}
                                >
                                    Informationen
                                </Typography>
                                <table className={classes.flexTable}>
                                    <tbody>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Projekt ID
                                        </th>
                                        <td className={classes.tableData}>
                                            {prismaRequest.id}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Name
                                        </th>
                                        <td className={classes.tableData}>
                                            {prismaRequest.name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}>Auftraggeber</th>
                                        <td className={classes.tableData}>

                                            <img
                                                width={'36px'}
                                                height={'36px'}
                                                src={
                                                    bpsUser.customerId === 7
                                                        ? '/img/rwe.png'
                                                        : bpsUser.customerId === 14
                                                            ? '/img/innogy.png'
                                                            : '/img/eon.png'
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Erstellt
                                        </th>
                                        <td className={classes.tableData}>
                                            {prismaRequest.created.format(
                                                DateTimeFormatter.ofPattern(
                                                    'dd.MM.yyyy',
                                                ),
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Admin
                                        </th>
                                        <td className={classes.tableData}>
                                            {
                                                assignedAdminName !== null
                                                    ? assignedAdminName
                                                    : '(noch nicht zugewiesen)'
                                            }
                                        </td>
                                    </tr>
                                    {assignedAdminEmail !== null &&
                                        <tr>
                                            <th className={classes.tableHeader}/>
                                            <td className={classes.tableData}>
                                                {assignedAdminEmail}
                                            </td>
                                        </tr>}
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Besteller
                                        </th>
                                        <td className={classes.tableData}>
                                            {bpsUser.firstName}{' '}
                                            {bpsUser.lastName}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}/>
                                        <td className={classes.tableData}>
                                            {bpsUser.email}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Auflage
                                        </th>
                                        <td className={classes.tableData}>
                                            {prismaRequest.amount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Anzahl Vorlagen
                                        </th>
                                        <td className={classes.tableData}>
                                            {printProduct.packingQuantity}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Gesamtstückzahl
                                        </th>
                                        <td className={classes.tableData}>
                                            {prismaRequest.amount * printProduct.packingQuantity}
                                        </td>
                                    </tr>
                                    {prismaRequest.desiredDeliveryDate !== null && <tr>
                                        <th className={classes.tableHeader}>
                                            Liefertermin
                                        </th>
                                        <td className={classes.tableData}>
                                            {prismaRequest.desiredDeliveryDate.format(
                                                DateTimeFormatter.ofPattern(
                                                    'dd.MM.yyyy HH:mm',
                                                ),
                                            )}
                                        </td>
                                    </tr>}
                                    {prismaRequest.desiredDeliveryAddress !== null && <tr>
                                        <th className={classes.tableHeader}>
                                            Lieferadresse
                                        </th>
                                        <td className={classes.tableData}>
                                            {prismaRequest.desiredDeliveryAddress}
                                        </td>
                                    </tr>}
                                    {(printOffer !== null
                                            || R.contains(prismaRequest.status, ['Ordered', 'Dispatched'])
                                        ) && printSapOrderNumber &&
                                        <tr>
                                            <th className={classes.tableHeader}>
                                                SAP Bestellnummer
                                            </th>
                                            <td className={classes.tableData}>
                                                {printSapOrderNumber}
                                            </td>
                                        </tr>}
                                    {(lithoOffer !== null)
                                        && lithoSapOrderNumber &&
                                        <tr>
                                            <th className={classes.tableHeader}>
                                                SAP Bestellnummer:
                                            </th>
                                            <td className={classes.tableData}>
                                                {lithoSapOrderNumber}
                                            </td>
                                        </tr>}
                                    </tbody>
                                </table>
                            </CardContent>
                        </Card>
                        {deliveryInformation !== null &&
                            <DeliveryInformationCard
                                classes={classes}
                                dispatch={dispatch}
                                deliveryInformation={deliveryInformation}
                                selectableParcelDispatchers={selectableParcelDispatchers}
                                selectedParcelDispatcher={selectedParcelDispatcher}
                                isSendingMarkAsDispatchedRequest={isSendingMarkAsDispatchedRequest}
                                isMarkAsDispatchedModalOpen={isMarkAsDispatchedModalOpen}
                                trackingNumber={trackingNumber}
                                prismaRequest={prismaRequest}
                            />
                        }
                        <Card className={classes.flexCard}>
                            <CardContent>
                                {
                                    printOffer === null && lithoOffer === null ?
                                        <RequestStatusView
                                            classes={classes}
                                            prismaRequest={prismaRequest}
                                        /> :
                                        <div>
                                            <OfferStatusView
                                                classes={classes}
                                                prismaRequest={prismaRequest}
                                                offerForm={printOffer}
                                                offerType="Print"
                                            />
                                            < OfferStatusView
                                                classes={classes}
                                                prismaRequest={prismaRequest}
                                                offerForm={lithoOffer}
                                                offerType="Litho"
                                            />
                                        </div>
                                }
                            </CardContent>
                        </Card>
                        <OfferFormView
                            classes={classes}
                            offerForm={printOffer}
                            offerType="Print"
                            deadline={prismaRequest.printOfferDeadline}
                            dispatch={dispatch}
                        />
                        <OfferFormView
                            classes={classes}
                            offerForm={lithoOffer}
                            offerType="Litho"
                            deadline={prismaRequest.lithoOfferDeadline}
                            dispatch={dispatch}
                        />
                    </div>
                    <div className={classes.row}>
                        <Card className={classes.flexCardPropertiesCard}>
                            <CardContent className={classes.flexContent}>
                                <div className={classes.flexColumn}>
                                    <Typography
                                        component="h2"
                                        className={classes.headline}
                                    >
                                        Eigenschaften
                                    </Typography>
                                    <table className={classes.flexTable}>
                                        <tbody>
                                        {R.map(
                                            attribute =>
                                                <tr key={attribute.key}>
                                                    <th className={classes.tableHeader}>
                                                        {attribute.key}
                                                    </th>
                                                    <td className={classes.tableData}>
                                                        {attribute.value}
                                                    </td>
                                                </tr>,
                                            translatedProductAttributes,
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className={classes.flexColumn}>
                                    <Typography
                                        component="h2"
                                        className={classes.headline}
                                    >
                                        Beschreibung
                                    </Typography>
                                    <Typography
                                        component="p"
                                        className={classes.description}
                                    >
                                        {prismaRequest.description}
                                    </Typography>
                                    <Divider className={classes.divider}/>
                                    <FileDownload
                                        classes={classes}
                                        dispatch={dispatch}
                                        prismaFileType={'Attachment'}
                                        downloadableFiles={attachmentFiles}
                                    />
                                    <FileDownload
                                        classes={classes}
                                        dispatch={dispatch}
                                        prismaFileType={'ProofCopy'}
                                        downloadableFiles={proofCopyFiles}
                                    />
                                    <FileDownload
                                        classes={classes}
                                        dispatch={dispatch}
                                        prismaFileType={'Print'}
                                        downloadableFiles={printFiles}
                                    />
                                    <FileUpload
                                        classes={classes}
                                        dispatch={dispatch}
                                    />
                                </div>
                            </CardContent>
                        </Card>
                        <Card className={classes.flexCard}>
                            <CardContent className={classes.flexContent}>
                                <Typography
                                    component="h2"
                                    className={classes.headline}
                                >
                                    Kommentare
                                </Typography>
                                <div className={classes.commentaryContent}>
                                    {R.map(
                                        prismaRequestCommentWithUsers => {
                                            const {prismaRequestComment} =
                                                prismaRequestCommentWithUsers
                                            return (
                                                <div
                                                    className={classes.commentaryComment}
                                                    key={prismaRequestCommentWithUsers.prismaRequestComment.id}
                                                >
                                                    <Typography
                                                        color="primary"
                                                        component="span"
                                                        className={classes.commentaryCommentTime}
                                                    >
                                                        {prismaRequestComment.created.format(minuteDateTimeFormatter())}
                                                    </Typography>
                                                    <Typography
                                                        component="span"
                                                        className={classes.commentaryCommentauthor}
                                                    >
                                                        {authorName(prismaRequestCommentWithUsers)}
                                                    </Typography>
                                                    <Typography
                                                        component="p"
                                                        className={classes.commentaryCommentText}
                                                    >
                                                        {/* TODO Zeilenumbrüche testen */}
                                                        {prismaRequestComment.text}
                                                    </Typography>
                                                </div>
                                            )
                                        },
                                        state.prismaRequestCommentsWithUsers,
                                    )}
                                </div>
                                <form
                                    className={classes.commentaryForm}
                                    onSubmit={
                                        event => {
                                            event.preventDefault()
                                            dispatch({type: 'CommentSubmit'})
                                        }
                                    }
                                >
                                    <TextField
                                        className={classes.commentaryTextInput}
                                        value={state.commentInput.text}
                                        onChange={
                                            event => dispatch({
                                                type: 'CommentTextChanged',
                                                value: event.target.value,
                                            })
                                        }
                                        multiline={true}
                                        placeholder="Kommentar schreiben"
                                        error={state.commentValidation.text !== null}
                                        helperText={errorMessage(state.commentValidation.text)}
                                    />
                                    <Button
                                        type="submit"
                                        className={classes.commentarySubmitButton}
                                        raised={true}
                                        color="primary"
                                    >
                                        Abschicken
                                    </Button>
                                </form>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            )
        },
    )

function DeliveryInformationCard(
    {
        classes,
        dispatch,
        deliveryInformation,
        selectableParcelDispatchers,
        selectedParcelDispatcher,
        isSendingMarkAsDispatchedRequest,
        isMarkAsDispatchedModalOpen,
        trackingNumber,
        prismaRequest
    }: WithClasses<{
        dispatch: (action: PrismaRequestDetailsAction) => void,
        deliveryInformation: PrismaRequestDeliveryInformation.M,
        selectableParcelDispatchers: ParcelDispatcher[] | null,
        selectedParcelDispatcher: ParcelDispatcher | null,
        isSendingMarkAsDispatchedRequest: boolean
        isMarkAsDispatchedModalOpen: boolean
        trackingNumber: string | null
        prismaRequest: PrismaRequest.M
    }>) {

    const nameDisplay =
        R.intersperse(
            <br/>,
            R.map(
                deliveryName => <React.Fragment>{deliveryName}</React.Fragment>,
                R.filter(
                    deliveryName => deliveryName !== null,
                    [
                        deliveryInformation.deliveryName1,
                        deliveryInformation.deliveryName2,
                        deliveryInformation.deliveryName3,
                        deliveryInformation.deliveryName4,
                    ],
                ),
            ),
        )

    const selectableParcelDispatchersMenuItems =
        selectableParcelDispatchers !== null ?
            R.map(
                parcelDispatcher => <MenuItem value={parcelDispatcher.id}>{parcelDispatcher.name}</MenuItem>,
                selectableParcelDispatchers,
            )
            : null

    return (
        <Card className={classes.flexCard}>
            <CardContent>
                <Typography
                    component="h2"
                    className={classes.headline}
                >
                    Lieferadresse
                </Typography>
                <table className={classes.flexTable}>
                    <tbody>
                    <tr>
                        <th
                            className={classes.tableHeader}
                            style={{
                                verticalAlign: 'top',
                                paddingTop: 0,
                            }}
                        >
                            Name
                        </th>
                        <td>
                            {nameDisplay}
                        </td>
                    </tr>
                    {deliveryInformation.deliveryRoom &&
                        <tr>
                            <th className={classes.tableHeader}>
                                Raum
                            </th>
                            <td className={classes.tableData}>
                                {deliveryInformation.deliveryRoom}
                            </td>
                        </tr>
                    }
                    {deliveryInformation.deliveryFloor &&
                        <tr>
                            <th className={classes.tableHeader}>
                                Stockwerk
                            </th>
                            <td className={classes.tableData}>
                                {deliveryInformation.deliveryFloor}
                            </td>
                        </tr>
                    }
                    <tr>
                        <th className={classes.tableHeader}>
                            Straße
                        </th>
                        <td className={classes.tableData}>
                            {deliveryInformation.deliveryStreet}
                        </td>
                    </tr>
                    {deliveryInformation.deliveryHousenumber &&
                        <tr>
                            <th className={classes.tableHeader}>
                                Hausnummer
                            </th>
                            <td className={classes.tableData}>
                                {deliveryInformation.deliveryHousenumber}
                            </td>
                        </tr>
                    }
                    <tr>
                        <th className={classes.tableHeader}>
                            PLZ
                        </th>
                        <td className={classes.tableData}>
                            {deliveryInformation.deliveryZipcde}
                        </td>
                    </tr>
                    <tr>
                        <th className={classes.tableHeader}>
                            Stadt
                        </th>
                        <td className={classes.tableData}>
                            {deliveryInformation.deliveryCity}
                        </td>
                    </tr>
                    <tr>
                        <th className={classes.tableHeader}>
                            Land
                        </th>
                        <td className={classes.tableData}>
                            {deliveryInformation.deliveryCountry}
                        </td>
                    </tr>
                    {prismaRequest.desiredDeliveryAddress !== null &&
                        <React.Fragment>
                            <tr>
                                <td
                                    colSpan={2}
                                    style={{
                                        fontSize: '16px',
                                        color: 'red'
                                    }}
                                >
                                    Bitte beachten Sie die eingegebene alternative Lieferadresse:
                                </td>
                            </tr>
                            <tr>
                                <td
                                    colSpan={2}
                                    style={{
                                        fontSize: '14px',
                                    }}
                                >
                                    {prismaRequest.desiredDeliveryAddress}
                                </td>
                            </tr>
                        </React.Fragment>
                    }
                    {deliveryInformation.parcel && deliveryInformation.parcelDispatcher &&
                        <React.Fragment>
                            <tr>
                                <th className={classes.tableHeader}>
                                    Versanddienstleister
                                </th>
                                <td className={classes.tableData}>
                                    {deliveryInformation.parcelDispatcher.name}
                                </td>
                            </tr>
                            {deliveryInformation.parcel.trackingNumber &&
                                <React.Fragment>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Trackingnummer
                                        </th>
                                        <td className={classes.tableData}>
                                            {deliveryInformation.parcel.trackingNumber}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableHeader}>
                                            Tracking Link
                                        </th>
                                        <td className={classes.tableData}>
                                            <a
                                                className={classes.wrapLink}
                                                href={deliveryInformation.parcelDispatcher.trackingUrl
                                                    + deliveryInformation.parcel.trackingNumber}
                                                target="_blank"
                                            >
                                                {deliveryInformation.parcelDispatcher.trackingUrl
                                                    + deliveryInformation.parcel.trackingNumber}
                                            </a>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }
                    </tbody>
                </table>
                {selectableParcelDispatchers !== null && deliveryInformation.parcel === null &&
                    <div>
                        <Typography
                            component="h2"
                            className={classes.headline}
                        >
                            Versenden
                        </Typography>
                        <FormControl
                            fullWidth={true}
                            className={classes.formControlSmallMargin}
                        >
                            <InputLabel htmlFor="shippingservice">
                                Versanddienstleister
                            </InputLabel>
                            <Select
                                value={
                                    selectedParcelDispatcher ? selectedParcelDispatcher.id : 1
                                }
                                onChange={
                                    (event) => {
                                        const parcelDispatcherId = parseInt(event.target.value, 10)
                                        const parcelDispatcher = R.find(
                                            pd => pd.id === parcelDispatcherId,
                                            selectableParcelDispatchers,
                                        )

                                        if (parcelDispatcher) {
                                            dispatch(
                                                {
                                                    type: 'ChangeSelectedParcelDispatcher',
                                                    value: parcelDispatcher,
                                                },
                                            )
                                        }
                                    }
                                }
                            >
                                {selectableParcelDispatchersMenuItems}
                            </Select>
                        </FormControl>
                        <FormControl
                            fullWidth={true}
                            className={classes.formControlSmallMargin}
                        >
                            <InputLabel htmlFor="trackingid">
                                Trackingnummer
                            </InputLabel>
                            <Input
                                type="text"
                                onChange={
                                    (event) => {
                                        dispatch(
                                            {
                                                type: 'ChangeTrackingNumber',
                                                value: event.target.value,
                                            },
                                        )
                                    }
                                }
                            />
                        </FormControl>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <Button
                                color="primary"
                                raised={true}
                                className={classes.raisedButton}
                                disabled={isSendingMarkAsDispatchedRequest}
                                onClick={
                                    () => {
                                        dispatch(
                                            {
                                                'type': 'ToggleMarkAsDispatchedModal',
                                                'open': true,
                                            },
                                        )
                                    }
                                }
                            >
                                Als versendet markieren
                            </Button>
                        </div>
                        {selectedParcelDispatcher && isMarkAsDispatchedModalOpen &&
                            <PrismaRequestMarkAsDispatchedModal
                                classes={classes}
                                dispatch={dispatch}
                                selectedParcelDispatcher={selectedParcelDispatcher}
                                trackingNumber={trackingNumber}
                            />
                        }
                    </div>
                }

            </CardContent>
        </Card>
    )
}

function FileDownload({classes, dispatch, prismaFileType, downloadableFiles}: WithClasses<{
    dispatch: (action: PrismaRequestDetailsAction) => void,
    prismaFileType: PrismaFileType.M,
    downloadableFiles: DownloadableFile.M<PrismaFile.M>[]
}>) {
    const title =
        (() => {
            switch (prismaFileType) {
                case 'Attachment':
                    return 'Anhänge'
                case 'ProofCopy':
                    return 'Korrekturabzüge'
                case 'Print':
                    return 'Druckdateien'
            }
        })()
    return (
        <div>
            <Typography
                component="h2"
                className={classes.headline}
            >
                {title}
            </Typography>
            <List>
                {downloadableFiles.length > 0 ?
                    R.map(
                        ({file, download}) =>
                            <ListItem
                                leftIcon={downloadIcon(download)}
                                key={file.id}
                                onClick={() =>
                                    dispatch({
                                        type: 'DownloadPrismaFile',
                                        prismaFileType,
                                        id: file.id,
                                        filename: file.filename,
                                    })
                                }
                            >
                                <ListItemText
                                    primary={file.filename}
                                />
                            </ListItem>,
                        downloadableFiles,
                    ) :
                    <ListItem>
                        <ListItemText
                            primary={'Keine'}
                        />
                    </ListItem>
                }
            </List>
        </div>
    )
}

function FileUpload({classes, dispatch}: WithClasses<{
    dispatch: (action: PrismaRequestDetailsAction) => void
}>) {
    return (
        <div>
            <Typography
                component="h2"
                className={classes.headline}
            >
                Upload für Dateien
            </Typography>
            <input
                type="file"
                onChange={
                    event => {
                        const input = event.currentTarget
                        if (input.files !== null && input.files.length === 1) {
                            dispatch({
                                type: 'UploadProofCopyFile',
                                file: input.files[0],
                            })
                        }
                        input.value = ''
                    }
                }
            />
        </div>
    )
}

function RequestStatusView({classes, prismaRequest}: WithClasses<{
    prismaRequest: PrismaRequest.M,
}>) {
    return (
        <div>
            <Typography
                component="h2"
                className={classes.headline}
            >
                Produktionsdaten {PrismaRequestOfferType.label('Print')}
            </Typography>
            <table className={classes.flexTable}>
                <tbody>
                <tr>
                    <th className={classes.tableHeader}>
                        Preis
                    </th>
                    <td className={classes.tableData}>
                        {prismaRequest.netPrintPrice !== null
                            ? `${formatPrice(prismaRequest.netPrintPrice)} €`
                            : '–'
                        }
                    </td>
                </tr>
                <tr>
                    <th className={classes.tableHeader}>
                        Menge
                    </th>
                    <td className={classes.tableData}>
                        {prismaRequest.amount}
                    </td>
                </tr>
                <tr>
                    <th className={classes.tableHeader}>
                        Status
                    </th>
                    <td className={classes.tableData}>
                        <PrismaManufacturerStatusView
                            status={getManufacturerStatusForStandardPrismaRequest(prismaRequest)}
                        />
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

function OfferStatusView({classes, prismaRequest, offerForm, offerType}: WithClasses<{
    prismaRequest: PrismaRequest.M,
    offerForm: OfferForm | null,
    offerType: PrismaRequestOfferType.M
}>) {
    if (offerForm === null) {
        return <div/>
    } else {
        const {prismaRequestOffer, manufacturerStatus} = offerForm
        return (
            <div>
                <Typography
                    component="h2"
                    className={classes.headline}
                >
                    Produktionsdaten {PrismaRequestOfferType.label(offerType)}
                </Typography>
                <table className={classes.flexTable}>
                    <tbody>
                    <tr>
                        <th className={classes.tableHeader}>
                            Abgegebener Preis
                        </th>
                        <td className={classes.tableData}>
                            {prismaRequestOffer.netPrice !== null
                                ? `${formatPrice(prismaRequestOffer.netPrice)} €`
                                : '–'
                            }
                        </td>
                    </tr>
                    {offerType === 'Print' &&
                        <tr>
                            <th className={classes.tableHeader}>
                                Menge
                            </th>
                            <td className={classes.tableData}>
                                {prismaRequest.amount}
                            </td>
                        </tr>
                    }
                    <tr>
                        <th className={classes.tableHeader}>
                            Status
                        </th>
                        <td className={classes.tableData}>
                            <PrismaManufacturerStatusView
                                status={manufacturerStatus}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

function OfferFormView({classes, offerForm, offerType, deadline, dispatch}: WithClasses<{
    offerForm: OfferForm | null,
    offerType: PrismaRequestOfferType.M,
    deadline: LocalDateTime | null,
    dispatch: (action: PrismaRequestDetailsAction) => void,
}>) {
    if (offerForm === null) {
        return <div/>
    } else {
        const {
            manufacturerStatus,
            priceValidation,
            priceInput,
            loading,
            error,
        } = offerForm

        if (manufacturerStatus !== 'PriceSubmissionPossible') {
            return <div/>
        }
        return (
            <Card className={classes.flexCard}>
                <CardContent>
                    <div>
                        <Typography
                            component="h2"
                            className={classes.headline}
                        >
                            Aktionen {offerType === 'Litho' ? 'Litho' : 'Druck'}
                        </Typography>
                        {manufacturerStatus === 'PriceSubmissionPossible' ?
                            <div>
                                <Typography
                                    component="p"
                                    className={classes.description}
                                >
                                    Hier können Sie einen Preis für
                                    das
                                    angebotene Produkt abgeben.
                                </Typography>
                                <Typography component="p">
                                    Angebotsfrist:
                                    {deadline !== null && deadline.format(minuteDateTimeFormatter())}
                                </Typography>
                                <form
                                    onSubmit={
                                        event => {
                                            event.preventDefault()
                                            dispatch({
                                                type: 'OpenPriceSubmitModal',
                                                offerType,
                                            })
                                        }
                                    }
                                >
                                    <FormControl
                                        fullWidth={true}
                                        className={classes.formControl}
                                        error={priceValidation.price !== null}
                                    >
                                        <InputLabel htmlFor="price">
                                            Preis angeben
                                        </InputLabel>
                                        <Input
                                            id="adornment-amount"
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    €
                                                </InputAdornment>
                                            }
                                            value={priceInput.price}
                                            onChange={
                                                event => dispatch({
                                                    type: 'PriceChanged',
                                                    value: event.target.value,
                                                    offerType,
                                                })
                                            }
                                        />
                                        <FormHelperText>
                                            {errorMessage(priceValidation.price)}
                                        </FormHelperText>
                                    </FormControl>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Button
                                            color="secondary"
                                            raised={true}
                                            className={classes.raisedButton}
                                            disabled={loading}
                                            onClick={
                                                () => {
                                                    dispatch(
                                                        {
                                                            type: 'OpenDeclineOfferModal',
                                                            offerType,
                                                        },
                                                    )
                                                }
                                            }
                                        >
                                            {error !== null &&
                                                <AlertError/>}
                                            Anfrage ablehnen
                                        </Button>
                                        <Button
                                            color="primary"
                                            raised={true}
                                            className={classes.raisedButton}
                                            disabled={loading || offerForm.priceInput.price === ''}
                                            type="submit"
                                        >
                                            {error !== null &&
                                                <AlertError/>}
                                            Abschicken
                                        </Button>
                                    </div>
                                    <PrismaRequestSubmitOfferModal
                                        state={offerForm}
                                        dispatch={dispatch}
                                    />
                                    <PrismaRequestDeclineOfferModal
                                        state={offerForm}
                                        dispatch={dispatch}
                                    />
                                </form>
                            </div> :
                            <Typography
                                component="p"
                                className={classes.description}
                            >
                                Zu diesem Zeitpunkt kann kein Preis
                                abgegeben werden.
                            </Typography>
                        }

                    </div>
                </CardContent>
            </Card>
        )
    }
}

function getManufacturerStatusForStandardPrismaRequest(prismaRequest: PrismaRequest.M): PrismaManufacturerStatus.M {

    switch (prismaRequest.status) {
        case 'Rejected':
            return 'Canceled'
        case 'Requested':
        case 'InQueue':
        case 'Approved':
            return 'Inactive'
        case 'Transferred':
        case 'Ordered':
        case 'Dispatched':
            return 'Ordered'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/PrismaRequestDetails/PrismaRequestDetailsView.tsx